import React from "react";
import Chat from "./Chat";
import { NewGroupModalComponent } from "./modals/NewGroupModal";
import { EditGroupModalComponent } from "./modals/EditGroupModal";
import { parseAthletesOrganizationInfoToClientListCoachRole } from "../../../utils/user-helpers";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const ChatController = async ({ res, req, locals, load }) => {
  const { query = {} } = req;
  const modal = query.modal || {};
  const {
    initId,
    groupParticipants,
    groupSubject,
    groupImage,
    groupChatId,
    allGroupChats,
  } = query;

  const isAllowToViewAllOrganizationsAthletes =
    locals.organizationRoleName &&
    (locals.organizationRoleName === "Owner" ||
      locals.organizationRoleName === "Admin" ||
      locals.organizationRoleName === "Nutritionist");

  if (
    locals.activeUser.organizationId &&
    isAllowToViewAllOrganizationsAthletes &&
    !locals.allAthletesFromOrganization
  ) {
    await load("allAthletesFromOrganization");
  }

  if (
    locals.activeUser.organizationId &&
    isAllowToViewAllOrganizationsAthletes &&
    !locals.usersOrganization
  ) {
    await load("usersOrganization");
  }

  const isRegularCoach =
    !locals.activeUser.organizationId &&
    locals.activeUser.permissions &&
    locals.activeUser.permissions.includes("coach");

  const athletesToShow =
    isRegularCoach ||
    (locals.organizationRoleName && locals.organizationRoleName === "Coach")
      ? parseAthletesOrganizationInfoToClientListCoachRole(locals.activeUser)
      : locals.allAthletesFromOrganization;

  //load modal
  locals.modal = {
    "create-chat-group": (
      <NewGroupModalComponent
        athletesToShow={athletesToShow}
        usersOrganization={locals.usersOrganization}
        activeUser={locals.activeUser}
        referAsClients={Boolean(locals.activeUser.referAsClients)}
        allGroupChats={allGroupChats}
      />
    ),
    "edit-chat-group": (
      <EditGroupModalComponent
        athletesToShow={athletesToShow}
        usersOrganization={locals.usersOrganization}
        activeUser={locals.activeUser}
        referAsClients={Boolean(locals.activeUser.referAsClients)}
        groupParticipants={groupParticipants}
        groupSubject={groupSubject}
        groupImage={groupImage}
        groupChatId={groupChatId}
        allGroupChats={allGroupChats}
      />
    ),
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  if (initId) res.body = <Chat initId={initId} />;
  else res.body = <Chat />;
};

export default ChatController;
